import { ALARM_DATE_FIELDS } from '../constants/alarm-date-fields.constant';
import { YachtAlarmDates } from '../types/alarms.interface';

export type LatestAlarm = { field: ALARM_DATE_FIELDS; value: string };

export const getLatestAlarm = (alarm: YachtAlarmDates): LatestAlarm | null =>
	(Object.keys(ALARM_DATE_FIELDS) as ALARM_DATE_FIELDS[]).reduce<LatestAlarm | null>((latest, field) => {
		const value = alarm[field];

		if (!value) return latest;

		if (latest && value <= latest.value) return latest;

		return { field, value };
	}, null);
